// This limit must match the Finance expense upload middleware, not quick capture.
export const MAX_EXPENSE_RECEIPTS_PER_UPLOAD = 100;
export const expenseReceiptCountError = (files) => files.length > MAX_EXPENSE_RECEIPTS_PER_UPLOAD
  ? `Puedes subir hasta ${MAX_EXPENSE_RECEIPTS_PER_UPLOAD} comprobantes nuevos por envío. No se agregó esta selección; elige menos archivos.`
  : '';

export const mergeExpenseReceiptFiles = (previous, selected) => {
  const key = (file) => `${file.name}:${file.size}:${file.lastModified}`;
  const known = new Set(previous.map(key));
  const files = [...previous];
  for (const file of selected) {
    if (!known.has(key(file))) { known.add(key(file)); files.push(file); }
  }
  const error = expenseReceiptCountError(files);
  // Never silently truncate a selection or discard previously selected receipts.
  return { files: error ? previous : files, error };
};
